import { useState, useEffect } from "react"
import loaderImg from "../assets/loader-logo.webp";
import loaderImgSvg from "../assets/loader-logo.svg";

export default function LoaderWrapper() {
    const [exiting, setExiting] = useState(false)
    const [visible, setVisible] = useState(true)

    useEffect(() => {
        // Trigger exit after a short delay to show the animation
        const t1 = setTimeout(() => setExiting(true), 200)
        const t2 = setTimeout(() => setVisible(false), 1400)
        return () => { clearTimeout(t1); clearTimeout(t2) }
    }, [])

    if (!visible) return null
    return <Loader exiting={exiting} />
}


export function Loader({ exiting = false }) {
    return (
        <div className={`loading ${exiting ? 'burst' : ''}`}>
            <div className="svg-wrap">
                {/* <svg width="64px" height="48px">
                    <polyline points="0.157 23.954, 14 23.954, 21.843 48, 43 0, 50 24, 64 24" id="back" />
                    <polyline points="0.157 23.954, 14 23.954, 21.843 48, 43 0, 50 24, 64 24" id="front" />
                </svg> */}
                <img src={loaderImgSvg} alt="Loading..." style={{ width: "64px"}} />
            </div>
            <h3 style={{ color: "#7281d4", margin: 0 }}>MOVEINMED</h3>
        </div>
    )
}



// import React from 'react'

// export default function Loader() {
//     return (
//         <>
//             <div className="loading">
//                 <svg width="64px" height="48px">
//                     <polyline points="0.157 23.954, 14 23.954, 21.843 48, 43 0, 50 24, 64 24" id="back"></polyline>
//                     <polyline points="0.157 23.954, 14 23.954, 21.843 48, 43 0, 50 24, 64 24" id="front"></polyline>
//                 </svg>
//                 <h3 style={{ color: "#7B7DE5", margin: 0 }}>MOVEINMED</h3>
//             </div>
//         </>
//     )
// }
